// import React, { useEffect, useState } from 'react';
// import { IconButton, Menu, MenuItem, Checkbox, FormGroup, FormControlLabel } from '@mui/material';
// import FilterAlt from '@mui/icons-material/FilterAlt';
// import { useDispatch } from 'react-redux';
// import './FilterMenu.css';

// const FilterMenu = () => {
//   const dispatch = useDispatch();
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [departments, setDepartments] = useState([]);
//   const [cameras, setCameras] = useState([])
//   const [selectedDepartments, setSelectedDepartments] = useState(['all']); 
//   const [allDepartmentsLabel, setAllDepartmentsLabel] = useState('All Departments');
//   const source = (localStorage.getItem('source'));

//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const handleDepartmentChange = (event) => {
//     const { name, checked } = event.target;
    
//     setSelectedDepartments(prev => {
//       let newSelection;
      
//       if (name === 'all') {
//         if (checked) {
//           newSelection = ['all', ...departments.map(dept => dept.name)];
//         } else {
//           newSelection = [];
//         }
//       } else {
//         if (checked) {
//           newSelection = [...prev.filter(item => item !== 'all'), name];
          
//           if (newSelection.length === departments.length) {
//             newSelection = ['all', ...newSelection];
//           }
//         } else {
//           newSelection = prev.filter(item => item !== name && item !== 'all');
//         }
//       }
      
//       const departmentsToDispatch = newSelection.includes('all') 
//         ? departments.map(dept => dept.name) 
//         : newSelection;
      
//       dispatch({ 
//         type: 'SET_DEPARTMENTS', 
//         departments: departmentsToDispatch 
//       });
      
//       return newSelection;
//     });
//   };

//   useEffect(() => {
//     const fetchDepartments = async () => {
//       try {
//         const response = await fetch('https://neoe2e.neophyte.live/iskcon-api/api/sentinel/getAllCameras', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             source_id: source
//           })
//         });

//         const data = await response.json();
//         console.log("dvd", data)
//         if (data && data.data && Array.isArray(data.data)) {
//           setDepartments(data);
          
//           if (data.data.length > 0) {
//             setAllDepartmentsLabel(`All`);
//             setSelectedDepartments(['all', ...data.data.map(dept => dept.device_name)]);
//             dispatch({ 
//               type: 'SET_DEPARTMENTS', 
//               departments: data.data.map(dept => dept.device_name) 
//             });
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching departments:', error);
//       }
//     };

//     if (source) {
//       fetchDepartments();
//     }
//   }, [source, dispatch]);







//   const isAllSelected = selectedDepartments.includes('all');
//   const isIndividualDepartmentSelected = (deptName) => {
//     return selectedDepartments.includes(deptName);
//   };

//   return (
//     <div>
//       <IconButton onClick={handleClick}>
//         <FilterAlt fontSize="large" className="filter-icon" />
//       </IconButton>
//       <Menu 
//         id="filter-menu" 
//         anchorEl={anchorEl} 
//         keepMounted 
//         open={Boolean(anchorEl)} 
//         onClose={handleClose}
//       >
//         <FormGroup>
//           <MenuItem style={{ fontWeight: 'bold' }}>Department</MenuItem>
//           <MenuItem sx={{ paddingTop: 0, paddingBottom: 0 }}>
//             <FormControlLabel 
//               control={
//                 <Checkbox 
//                   checked={isAllSelected}
//                   onChange={handleDepartmentChange} 
//                   name="all" 
//                 />
//               } 
//               label={allDepartmentsLabel}
//             />
//           </MenuItem>
//           {departments.map((dept, index) => (
//             <MenuItem key={dept.name || index} sx={{ paddingTop: 0, paddingBottom: 0 }}>
//               <FormControlLabel
//                 control={
//                   <Checkbox 
//                     checked={isIndividualDepartmentSelected(dept.name)}
//                     onChange={handleDepartmentChange} 
//                     name={dept.name} 
//                   />
//                 }
//                 label={dept.name}
//               />
//             </MenuItem>
//           ))}
//         </FormGroup>
//       </Menu>
//     </div>
//   );
// };

// export default FilterMenu;




import React, { useEffect, useState } from 'react';
import { IconButton, Menu, MenuItem, Checkbox, FormGroup, FormControlLabel } from '@mui/material';
import FilterAlt from '@mui/icons-material/FilterAlt';
import { useDispatch } from 'react-redux';
import './FilterMenu.css';

const FilterMenu = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [departments, setDepartments] = useState([]); // this will hold cameras array from API
  const [selectedDepartments, setSelectedDepartments] = useState(['all']);
  const [allDepartmentsLabel, setAllDepartmentsLabel] = useState('All');
  const source = localStorage.getItem('source');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDepartmentChange = (event) => {
    const { name, checked } = event.target;

    setSelectedDepartments((prev) => {
      let newSelection;

      if (name === 'all') {
        if (checked) {
          newSelection = ['all', ...departments.map((d) => d.device_name)];
        } else {
          newSelection = [];
        }
      } else {
        if (checked) {
          // add this camera; also strip 'all' if present
          newSelection = [...prev.filter((item) => item !== 'all'), name];

          // if all individual cameras are selected, prepend 'all'
          if (newSelection.length === departments.length) {
            newSelection = ['all', ...newSelection];
          }
        } else {
          // remove this camera and also remove 'all' (since it's no longer all)
          newSelection = prev.filter((item) => item !== name && item !== 'all');
        }
      }

      const departmentsToDispatch = newSelection.includes('all')
        ? departments.map((d) => d.device_name)
        : newSelection;

      dispatch({
        type: 'SET_DEPARTMENTS',
        departments: departmentsToDispatch,
      });

      return newSelection;
    });
  };

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await fetch(
          'https://neoe2e.neophyte.live/iskcon-api/api/sentinel/getAllCameras',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              source_id: source,
            }),
          }
        );

        const data = await response.json();
        console.log('dvd', data);

        if (data && Array.isArray(data.cameras)) {
          // store cameras array
          setDepartments(data.cameras);

          if (data.cameras.length > 0) {
            setAllDepartmentsLabel('All');
            const allNames = data.cameras.map((d) => d.device_name);
            setSelectedDepartments(['all', ...allNames]);
            dispatch({
              type: 'SET_DEPARTMENTS',
              departments: allNames,
            });
          } else {
            // empty case
            setSelectedDepartments([]);
            dispatch({
              type: 'SET_DEPARTMENTS',
              departments: [],
            });
          }
        } else {
          console.error('Unexpected response shape:', data);
          setDepartments([]);
          setSelectedDepartments([]);
          dispatch({ type: 'SET_DEPARTMENTS', departments: [] });
        }
      } catch (error) {
        console.error('Error fetching departments:', error);
        setDepartments([]);
        setSelectedDepartments([]);
        dispatch({ type: 'SET_DEPARTMENTS', departments: [] });
      }
    };

    if (source) {
      fetchDepartments();
    }
  }, [source, dispatch]);

  const isAllSelected = selectedDepartments.includes('all');
  const isIndividualDepartmentSelected = (deptName) => {
    return selectedDepartments.includes(deptName);
  };

  return (
    <div>
      <IconButton onClick={handleClick}>
        <FilterAlt fontSize="large" className="filter-icon" />
      </IconButton>
      <Menu
        id="filter-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <FormGroup>
          <MenuItem style={{ fontWeight: 'bold' }}>Cameras</MenuItem>
          <MenuItem sx={{ paddingTop: 0, paddingBottom: 0 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isAllSelected}
                  onChange={handleDepartmentChange}
                  name="all"
                />
              }
              label={allDepartmentsLabel}
            />
          </MenuItem>

          {departments.map((dept, index) => {
            const key = dept._id || dept.device_name || index;
            const name = dept.device_name; // use device_name from API
            return (
              <MenuItem key={key} sx={{ paddingTop: 0, paddingBottom: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isIndividualDepartmentSelected(name)}
                      onChange={handleDepartmentChange}
                      name={name}
                    />
                  }
                  label={name}
                />
              </MenuItem>
            );
          })}
        </FormGroup>
      </Menu>
    </div>
  );
};

export default FilterMenu;
